import { z } from 'zod';

const LawModel = z.object({
  id: z.string(),
  number: z.string(),
  name: z.string(),
});

export const LawsModel = LawModel.array();

export const LawArticlesModel = z.object({
  articleTitles: z.string().array(),
});

export const LawParagraphsModel = z.object({
  paragraphs: z.string().array(),
});
